import React, { useContext } from 'react';
//@ts-ignore
import * as styles from './product-specifications.module.css';
import {
    KontentStringValue,
    CTAConfiguration,
    CTALocation,
    KontentProductImage,
} from '../../../types/KontentProps';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import { getLangPrefix } from '../../global/countries';
import { getMultiChoice } from '../Global/DataUtils';
import CtaLink from '../Global/CtaLink';
import LazyImage from '../Global/LazyImage';
import { epigraphCTA } from '.';
import LazyEpigraphButton from '../../global/lazyEpigraphButton';
import { resolveEpigraphSku } from '../../utils/epigraphSku';

export interface ProductSpecificationDocument {
    elements: any;
    cta_label: KontentStringValue;
    cta_location: CTAConfiguration;
    cta_location_anchor_point: KontentStringValue;
    cta_window_action: any;
}

interface Props {
    documents: ProductSpecificationDocument[];
    epigraphCTA?: epigraphCTA;
}

const ProductSpecsLinks: React.FC<Props> = ({ documents, epigraphCTA }) => {
    const ctaAnchorValue =
        documents[0]?.elements?.cta_location_anchor_point?.value;
    const epigraphCtaBoxIcon =
        epigraphCTA?.cta_icons?.value[0]?.elements?.file?.value[0]?.url;
    const epigraphCtaBoxHoverIcon =
        epigraphCTA?.cta_icons?.value[1]?.elements?.file?.value[0]?.url;
    const epigraphCtaTarget =
        getMultiChoice(epigraphCTA?.cta_configuration__cta_window_action) ===
        'new_window'
            ? '_blank'
            : 'self';
    const pageMetadata = useContext(PageMetadataContext);
    const epigraphCtaSku = resolveEpigraphSku(
        undefined,
        epigraphCTA?.sku?.value,
        pageMetadata.slug
    );

    return (
        <div className={styles.links} id={ctaAnchorValue || undefined}>
            {epigraphCTA && epigraphCtaSku && (
                <>
                    <LazyEpigraphButton
                        key={epigraphCtaSku}
                        sku={epigraphCtaSku}
                    >
                        <button
                            slot="slot-custom-view-in-your-space-button"
                            className={styles.epigraphBtn}
                        >
                            <span className={styles.boxIcons}>
                                <LazyImage
                                    src={epigraphCtaBoxIcon}
                                    alt=""
                                    width={60}
                                    height={60}
                                />
                                <LazyImage
                                    src={epigraphCtaBoxHoverIcon}
                                    alt=""
                                    width={60}
                                    height={60}
                                />
                            </span>
                            <span data-kontent-element-codename="cta_copy">
                                {epigraphCTA?.cta_copy?.value}
                            </span>
                        </button>
                    </LazyEpigraphButton>

                    <div className={styles.helperText}>
                        <CtaLink
                            href={
                                epigraphCTA?.cta_configuration__cta_location
                                    ?.value[0]?.elements?.slug?.url
                            }
                            target={epigraphCtaTarget}
                        >
                            {epigraphCTA?.cta_configuration__cta_label?.value}
                        </CtaLink>
                    </div>
                </>
            )}
            {documents?.map((document) => {
                const isFile = document?.elements?.cta_location?.value[0]
                    ?.elements?.file
                    ? true
                    : false;
                let ctaAnchor = '';
                if (!isFile) {
                    const preferredLanguage =
                        pageMetadata.preferredLanguage || 'default';
                    var slugUrl = `${getLangPrefix(preferredLanguage)}${
                        document.elements.cta_location.value[0]?.elements?.slug
                            ?.url
                    }`;

                    ctaAnchor = document.elements.cta_location_anchor_point
                        ?.value
                        ? `/#${document.elements.cta_location_anchor_point.value}`
                        : '';
                }

                return (
                    <a
                        key={document.elements.cta_label.value}
                        href={
                            slugUrl
                                ? slugUrl + ctaAnchor
                                : document.elements.cta_location.value[0]
                                      ?.elements?.file?.value[0]?.url || ''
                        }
                        rel={
                            document.elements.cta_window_action?.value[0]
                                .codename !== 'same_window'
                                ? document?.elements?.cta_location?.value[0]?.elements?.file?.value[0]?.url.endsWith(
                                      '.pdf'
                                  )
                                    ? 'noopener noreferrer nofollow'
                                    : 'noopener noreferrer'
                                : document?.elements?.cta_location?.value[0]?.elements?.file?.value[0]?.url.endsWith(
                                      '.pdf'
                                  )
                                ? 'nofollow'
                                : undefined
                        }
                        target={
                            document.elements.cta_window_action?.value[0]
                                .codename === 'same_window'
                                ? '_self'
                                : '_blank'
                        }
                        data-kontent-element-codename="cta_label"
                    >
                        {document.elements.cta_label?.value}
                    </a>
                );
            })}
        </div>
    );
};

export default ProductSpecsLinks;
